export default __webpack_public_path__ + "static/media/webyliaLogoBN.972177ce.png";